// =============================================================================
// CardHeaderGetm Component - GETM Design System
// Componente reutilizable para headers de cards con título e icono de información
// =============================================================================

import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

export type CardHeaderAlignment = 'center' | 'start';

@Component({
  selector: 'app-card-header-getm',
  templateUrl: './card-header-getm.component.html',
  styleUrls: ['./card-header-getm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CardHeaderGetmComponent {
  /** Clave de traducción i18n para el título */
  @Input() titleKey: string = '';

  /** Título directo (alternativa a titleKey) */
  @Input() title: string = '';

  /** Mostrar/ocultar icono de información */
  @Input() showInfoIcon: boolean = true;

  /** Alineación del header: 'center' | 'start' */
  @Input() alignment: CardHeaderAlignment = 'center';

  /** Color del icono de información */
  @Input() infoIconColor: string = '';

  /** Evento emitido al hacer click en el icono de información */
  @Output() infoClick = new EventEmitter<void>();

  public onInfoClick(): void {
    this.infoClick.emit();
  }
}
